import { useMemo } from "react";
import { useTheme } from "src/hooks";
import { type ICol } from "src/interfaces";

import { generateHeaders } from "../../../generator/PortraitOrientation/PortraitSection/PortraitSectionHeaders/generateHeaders";
import { expandCollapsedHeaders } from "../../../generator/PortraitOrientation/PortraitSection/PortraitSectionHeaders/generateHeaders.utils";

interface Props {
  headers: ICol[];
  sIndex: number;
  headerSize?: string;
  entryIndex?: number;
  offset?: number;
  pdfEntry?: boolean;
  hideHeaders?: boolean;
  layout?: number[];
  sticky?: boolean;
}

const Header = ({
  headers,
  sIndex,
  headerSize,
  entryIndex,
  offset,
  pdfEntry,
  hideHeaders,
  layout,
  sticky = true,
}: Props) => {
  const theme = useTheme() as any;
  const generatedHeaders = useMemo(
    () =>
      generateHeaders({
        // Read-only views show every column, whatever was collapsed on saving.
        headers: expandCollapsedHeaders(headers),
        theme,
        headerSize,
        headerRef: null,
        sectionIndex: sIndex,
        NMEAButton: false,
        summary: true,
        omitThead: true,
        entryIndex,
        pdfEntry,
        hideHeaders,
        layout,
      }),
    [
      headers,
      theme,
      headerSize,
      entryIndex,
      hideHeaders,
      layout,
      pdfEntry,
      sIndex,
    ],
  );
  return (
    <thead
      style={
        sticky
          ? {
              position: "sticky",
              top: `calc(-3px + ${offset ?? -13}px)`,
              width: "100%",
              zIndex: 4,
            }
          : { width: "100%" }
      }>
      {generatedHeaders}
    </thead>
  );
};

export default Header;
